import React from 'react';
import { CTAButton, TrustLine } from './CTAButton';
import { BOX_IMAGE, PURCHASE_ANCHOR } from '../data/content';
export function FinalCTA() {
  return <section className="bg-deep px-4 py-6 text-center sm:px-6" data-id="element-50" data-mp="3uei1xeuj5o1t">
      <div className="mx-auto max-w-2xl" data-id="element-51" data-mp="c7tzjwqv7ezu">
        <h2 className="font-heading text-base font-extrabold uppercase text-glow sm:text-2xl" data-id="element-52" data-mp="c4fuggqtgrop">
          One last question
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.86rem] leading-snug text-white/85 sm:text-base" data-id="element-53" data-mp="m46oyifdn6os">
          How many times have you studied an ophthalmic image knowing what you
          were looking for... but still had to search scattered references and
          compare disconnected images again? You can keep moving between
          images, textbooks, references and separate resources. Or you can open
          one organized professional system.
        </p>
        <p className="mt-1.5 font-heading text-[0.8rem] font-bold uppercase text-turq sm:text-base" data-id="element-54" data-mp="zwd5w6qcthpa">
          Observe. Compare. Connect. Recognize.
        </p>

        <a href={PURCHASE_ANCHOR} className="mt-2 block" data-id="element-55" data-mp="2c67sapgt7m91">
          <img src={BOX_IMAGE} alt="OPHTHALMOLOGY VISUAL ATLAS™ complete system" className="mx-auto w-full max-w-[210px] drop-shadow-2xl" data-id="element-56" data-mp="2h37xyz9qymzm" />
        </a>

        <p className="mt-1.5 font-heading text-lg font-extrabold uppercase text-white sm:text-2xl" data-id="element-57" data-mp="2r2gotj9bflhr">
          👁️ Ophthalmology Visual Atlas™
        </p>
        <p className="font-heading text-[0.72rem] font-semibold uppercase tracking-wide text-white/85 sm:text-sm" data-id="element-58" data-mp="2v3900i1r00go">
          The Complete Visual Study System for Ophthalmology
        </p>
        <p className="mt-0.5 text-[0.72rem] text-white/70 sm:text-sm" data-id="element-59" data-mp="34tu24fgmrn4c">
          OCT Patterns • Fundus &amp; Retina • Optic Nerve • Visual Fields •
          Corneal Imaging • Multimodal Integration
        </p>

        <p className="mt-2.5 font-heading text-[0.92rem] font-extrabold uppercase text-glow sm:text-lg" data-id="element-60" data-mp="3epf104qek79v">
          🔥 Get the complete system today
        </p>
        <div className="mx-auto mt-1.5 max-w-md" data-id="element-61" data-mp="1jpen3mbmzmx9">
          <CTAButton label="👁️ Get Ophthalmology Visual Atlas™" sub="Immediate Access • Digital Delivery" data-id="element-62" data-mp="1jlz3c670pppi" />
          <TrustLine className="mt-2 !text-white/80" data-id="element-63" data-mp="1sgx41zgeq6re" />
        </div>
      </div>
    </section>;
}